// extracted by mini-css-extract-plugin
module.exports = {"lg":"(min-width: 1024px)","feature-box--card-link":"FeatureBox_feature-box--card-link__2tFye"};